module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "side-panel-overlay",
    class: {
      'open': _vm.open
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "view-container",
    class: {
      'open': _vm.open
    }
  }, [_c('span', {
    staticClass: "side-panel-close",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "side-panel-close-inner"
  })]), _vm._v(" "), _c('span', {
    staticClass: "side-panel-print side-panel-print-visible",
    attrs: {
      "title": "Print"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-rest wrapper overflow-auto"
  }, [(_vm.loading) ? _c('div', [_vm._v("\n        Verificando... "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _c('div', [_c('div', {
    staticClass: "m-b row"
  }, [_vm._v("\n          Selecione o leilão de destino da cópia dos lotes:\n          "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.leiloes), function(leilao) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.leilaoNovoId),
        expression: "leilaoNovoId"
      }],
      attrs: {
        "id": 'leilao' + leilao.id,
        "type": "radio"
      },
      domProps: {
        "value": leilao.id,
        "checked": _vm._q(_vm.leilaoNovoId, leilao.id)
      },
      on: {
        "change": function($event) {
          _vm.leilaoNovoId = leilao.id
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'leilao' + leilao.id
      }
    }, [_vm._v(_vm._s(leilao.titulo) + " / ID " + _vm._s(leilao.id) + " / Data:\n            " + _vm._s(_vm.moment(leilao.dataAbertura.date).format('L')) + "\n            " + _vm._s(_vm.moment(leilao.dataAbertura.date).format('LTS')))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "m-b row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('u-button', {
    staticClass: "btn btn-dark pull-right",
    attrs: {
      "disabled": _vm.isSending
    },
    on: {
      "click": _vm.enviar
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope m-r-xs"
  }), _vm._v(" Transferir como cópia\n            ")])], 1)]), _vm._v(" "), _c('table', {
    staticClass: "table table-clicked table-striped bg-white b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30px"
    }
  }, [_c('label', {
    staticClass: "i-checks m-b-none"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selecionarTudo),
      expression: "selecionarTudo"
    }],
    attrs: {
      "type": "checkbox",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.selecionarTudo) ? _vm._i(_vm.selecionarTudo, null) > -1 : (_vm.selecionarTudo)
    },
    on: {
      "click": _vm.selectAll,
      "change": function($event) {
        var $$a = _vm.selecionarTudo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selecionarTudo = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selecionarTudo = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selecionarTudo = $$c
        }
      }
    }
  }), _c('i')])]), _vm._v(" "), _c('th', [_vm._v("LT")]), _vm._v(" "), _c('th', [_vm._v("Título")]), _vm._v(" "), _c('th', [_vm._v("Comunicados")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.lotes), function(lote) {
    return _c('tr', [_c('td', [_c('label', {
      staticClass: "i-checks m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (lote.checked),
        expression: "lote.checked"
      }],
      attrs: {
        "type": "checkbox",
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(lote.checked) ? _vm._i(lote.checked, null) > -1 : (lote.checked)
      },
      on: {
        "change": function($event) {
          var $$a = lote.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(lote, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(lote, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(lote, "checked", $$c)
          }
        }
      }
    }), _c('i')])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lote.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lote.titulo))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticStyle: {
        "background": "#000000"
      },
      style: ({
        'color': _vm.getStatus[lote.status].color
      })
    }, [_vm._v(_vm._s(_vm.getStatus[lote.status].titulo) + "\n              "), (lote.sending) ? _c('div', {
      staticStyle: {
        "color": "cyan"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-spin"
    }), _vm._v(" Copiando")]) : _vm._e(), _vm._v(" "), (lote.sendedError) ? _c('div', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(lote.sendedError))]) : _vm._e(), _vm._v(" "), (lote.sended) ? _c('div', {
      staticClass: "text-nowrap",
      staticStyle: {
        "color": "greenyellow"
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    }), _vm._v("\n                Copiado com sucesso!\n              ")]) : _vm._e()])])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ddafc62","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/CopiarLotesView.vue
// module id = 1766
// module chunks = 17